import styled from 'styled-components'

export const NoticeItem = styled.li`
  list-style-type: '* ';
  font-weight: 400;
  font-size: 13px;
  line-height: 150%;
  color: #9a9c9c;
`
